import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a href="https://www.instagram.com/caiqueberlin/" className="home__social-icon" target="_blank">
        <i className="uil uil-instagram"></i>
      </a>

      <a
        href="https://www.linkedin.com/in/carlos-pereira-0b847b235/"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-linkedin"></i>
      </a>

      <a
        href="https://github.com/CarlosPereira85"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-github-alt"></i>
      </a>
    </div>
  );
};

export default Social;
